import { AbstractControl, ValidatorFn } from '@angular/forms';

export function JsonValidator(): ValidatorFn {
  return (control: AbstractControl) => {
    if (!control.value) {
      return null; // Allow empty values
    }

    try {
      JSON.parse(control.value);
      return null; // Valid JSON
    } catch (error) {
      return { 'json-format': { message: 'Invalid JSON format' } };
    }
  };
}